import React from 'react';
import { motion } from 'framer-motion';
import { Book } from 'lucide-react';
export function CTASection() {
  return <section className="py-24 relative overflow-hidden bg-forest-dark" data-id="element-77">
      {/* Background Image with heavy overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat opacity-20" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/wrif2SzPzaXgRaFVQfvwPa/IMAGEN_5_LEYES_(PORTADA).png")'
    }} data-id="element-78" />
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-forest-dark via-forest-dark/80 to-transparent" data-id="element-79" />

      <div className="container mx-auto px-6 relative z-20 text-center max-w-3xl" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-81">
          <h2 className="font-display text-4xl md:text-5xl text-gold-light font-bold mb-6" data-id="element-82">
            Comienza tu Transformación
          </h2>
          <p className="text-white text-lg md:text-xl mb-10 leading-relaxed" data-id="element-83">
            Descubre el mensaje oculto detrás de tus síntomas y recupera la
            confianza en la infinita sabiduría de tu cuerpo.
          </p>

          <motion.a href="https://www.linochicastore.com/cart/40962739503153:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'Del Dolor a la Conciencia',
              content_type: 'product',
              value: 6.39,
              currency: 'USD'
            });
          }
        }} whileHover={{
          scale: 1.05,
          boxShadow: '0 0 20px rgba(212, 175, 55, 0.4)'
        }} whileTap={{
          scale: 0.95
        }} className="bg-gradient-to-r from-gold-dark via-gold to-gold-dark text-forest-dark font-bold text-lg px-10 py-4 rounded-full flex items-center gap-3 mx-auto shadow-lg shadow-gold/20 transition-all cursor-pointer no-underline" data-id="element-84">
            <Book className="w-5 h-5" data-id="element-85" />
            <span data-id="element-86">Consigue tu copia hoy</span>
          </motion.a>

          <p className="mt-6 text-white text-sm" data-id="element-87">
            Disponible en formato físico y digital
          </p>
        </motion.div>
      </div>
    </section>;
}